import { ApiKeys } from '@app/constants/api-keys'
import { IRegion } from '@app/interfaces/organization/region'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyOrganizationApi } from '.'
import { IRtkResponse } from '../../types'

export const regionApi = emptyOrganizationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getRegions: build.query<IRtkResponse<IRegion[]>, URLSearchParams | string>({
      query: (args = '') => ({
        url: 'dictionary/api/v1/regions',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IRegion[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.region,
                id,
              })),
              { type: ApiKeys.region, id: 'LIST' },
            ]
          : [{ type: ApiKeys.region, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.region, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getRegion: build.query<IRegion, number>({
      query: (id) => ({
        url: `dictionary/api/v1/regions/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: ApiKeys.region, id }],
    }),
  }),
})

export const { useGetRegionsQuery, useGetRegionQuery } = regionApi
